import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';

dayjs.extend(customParseFormat);

const DATE_FORMAT = 'YYYY-MM-DD';
export const OPERATION_ANALYSIS_METADATA_STALE_TIME = 5 * 60 * 1000;
const SHANGHAI_DATE_FORMATTER = new Intl.DateTimeFormat('en-US', {
  day: '2-digit',
  month: '2-digit',
  timeZone: 'Asia/Shanghai',
  year: 'numeric',
});

export const getMetricEffectivePeriodQueryKey = (organizationId) => [
  'metric-effective-period',
  organizationId,
];

export const getMetricEffectiveStartDate = (effectiveStartAt) => {
  if (!Number.isFinite(effectiveStartAt)) {
    return null;
  }
  const parts = SHANGHAI_DATE_FORMATTER.formatToParts(new Date(effectiveStartAt)).reduce(
    (result, part) => ({ ...result, [part.type]: part.value }),
    {},
  );
  return dayjs(`${parts.year}-${parts.month}-${parts.day}`, DATE_FORMAT, true);
};

export const toMetricEffectiveStartAt = (effectiveStartDate) => {
  const date = dayjs.isDayjs(effectiveStartDate)
    ? effectiveStartDate
    : dayjs(effectiveStartDate, DATE_FORMAT, true);
  return date.isValid() ? Date.parse(`${date.format(DATE_FORMAT)}T00:00:00+08:00`) : null;
};

export const clampMetricDateRange = ([start, end], effectiveStartDate) => {
  if (!effectiveStartDate) {
    return [start, end];
  }
  const nextStart = start.isBefore(effectiveStartDate, 'day') ? effectiveStartDate : start;
  return [nextStart, end.isBefore(nextStart, 'day') ? nextStart : end];
};

const getShanghaiBusinessDate = (value) => {
  const date = dayjs.isDayjs(value) ? value.toDate() : value;
  const parts = SHANGHAI_DATE_FORMATTER.formatToParts(date).reduce(
    (result, part) => ({ ...result, [part.type]: part.value }),
    {},
  );
  return dayjs(`${parts.year}-${parts.month}-${parts.day}`, DATE_FORMAT, true);
};

export const getPreviousMonthToDateRange = (today = new Date(), effectiveStartDate = null) => {
  const normalizedToday = getShanghaiBusinessDate(today);
  return clampMetricDateRange(
    [normalizedToday.subtract(1, 'month').startOf('month'), normalizedToday],
    effectiveStartDate,
  );
};

export const getMetricDateRangePresets = (effectiveStartDate, getNow = () => new Date()) => [
  {
    label: '本月',
    value: () => {
      const today = getShanghaiBusinessDate(getNow());
      return clampMetricDateRange([today.startOf('month'), today], effectiveStartDate);
    },
  },
  {
    label: '上月',
    value: () => {
      const previousMonth = getShanghaiBusinessDate(getNow()).subtract(1, 'month');
      return clampMetricDateRange(
        [previousMonth.startOf('month'), previousMonth.endOf('month').startOf('day')],
        effectiveStartDate,
      );
    },
  },
  {
    label: '上月至今',
    value: () => getPreviousMonthToDateRange(getNow(), effectiveStartDate),
  },
];
